module.exports = __webpack_public_path__ + "static/media/iStock-135649264.0e730e50.jpg";